import React, { useEffect ,useState} from 'react';
import { PDFDownloadLink } from '@react-pdf/renderer';
import PDFContainer from './pdfContainer';

const PDFDownload = (props) => {
    let { selectedScheduleReport } = props;
    const [downloadedPdfGameIds] = useState([]);

    const exportToPDF = (id) => {
        let searchElement = "#" + id + " a";
        let element = document.querySelector(searchElement);
        let mainDiv = document.getElementById(id);
        if (element && element.textContent.trim() === 'Download' &&
            mainDiv && mainDiv.style.display !== 'none') {
            element.click();
            mainDiv.style.display = 'none';

             let downloadedIds = [...downloadedPdfGameIds];
             downloadedIds.push(id);
            if (props.selectedScheduleReport && downloadedIds
                && props.selectedScheduleReport.length === downloadedIds.length) {
                props.setSelectedScheduleReport([]);
            }

            props.open(false);
        }
    }

    const PDFDownloadItem = (props) => {
        const [PDFLoaded, setPDFLoaded] = React.useState(false);
        let { data, fileName, exportToPDF, id } = props;

        useEffect(() => {
            if (PDFLoaded) {
                exportToPDF(id)
            }

        }, [PDFLoaded])

        return (
            <div id={id}
                style={{ display: 'flex', flexDirection: 'row' }}>
                <PDFDownloadLink
                    document={<PDFContainer data={data} />}
                    fileName={fileName}
                >
                    {({ url, loading }) => {
                        if (!loading && url) {
                            setPDFLoaded(true);
                        }

                        return (
                            loading ? "" : "Download"
                        )
                    }

                    }
                </PDFDownloadLink>

            </div>
        )
    }


    return (
        <div>
            {
                (selectedScheduleReport && selectedScheduleReport.length > 0) &&
                selectedScheduleReport.map((i, index) => {
                    
                    let fileName = i.participantName + '.pdf';
                        
                    return (
                        <PDFDownloadItem key={index}
                            id={'divToPrint_' + index}
                            fileName={fileName}
                            data={i}
                            exportToPDF={exportToPDF}
                        />
                    )
                })
            }
        </div>
    )

}

export default PDFDownload;
